import { Pipe, PipeTransform } from '@angular/core';
import { BodyPartService } from 'src/app/shared/services/body-part.service';

@Pipe({
  name: 'woundLocation',
})
export class WoundLocationPipe implements PipeTransform {
  constructor(private bpp: BodyPartService) {}
  transform(value: any, ...args) {
    if (value === 'undefined' || value == null || isNaN(value)) {
      return 'ohne Lokalisation';
    }
    const bodyPart = this.bpp.bodyParts.find(f => f.areaId.toString() === value.toString());
    if (bodyPart) {
      return `${bodyPart.part} ${bodyPart.half} ${bodyPart.view}`;
    }
  }
}
